import { Navbar } from "./components/navbar/Navbar.jsx";
import { AllRoutes } from "./components/routing/AllRoutes.jsx";


function App() {
  return (
  <>
    <Navbar />
    <AllRoutes />
  </>
  );
}

export default App;
